import { render, staticRenderFns } from "./_base-loading.vue?vue&type=template&id=f8c0dde6&scoped=true"
import script from "./_base-loading.vue?vue&type=script&lang=js"
export * from "./_base-loading.vue?vue&type=script&lang=js"
import style0 from "./_base-loading.vue?vue&type=style&index=0&id=f8c0dde6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c0dde6",
  null
  
)

export default component.exports